module.exports = __webpack_public_path__ + "static/media/teachers-logo--text-right.9b28d87e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/teachers/teachers-logo--text-right.svg
// module id = 182
// module chunks = 0